import { Delete, Pencil, Tick } from "assets/icons/Common";
import { Button, Col, IconButtonInverted, Row } from "components/primitives";
import styled from "styled-components";

import { SavedGroupConfigurations } from "./types";

interface CurrentScheduleSettingItemProps {
  item: SavedGroupConfigurations;
  onClick: () => void;
  index: number;
  dataLength: number;
  onDelete?: () => void;
  onAdd?: () => void;
  handleClickOnConfigName: () => void;
  selectedGroupConfigIndex: number | undefined;
  settings: any;
}

export const CurrentGroupConfigSettingItem = ({
  item,
  onClick,
  onDelete,
  handleClickOnConfigName,
  selectedGroupConfigIndex,
  settings,
}: CurrentScheduleSettingItemProps) => {
  const isSelected =
    item?.id === selectedGroupConfigIndex || item?.id === settings?.organise?.[0]?.id;
  return (
    <div>
      <GroupConfigItem>
        <GroupConfigItemInner>
          <ConfigItem color={isSelected ? "#b4ade9" : "#8f84de"} onClick={handleClickOnConfigName}>
            <Row>
              <Col>
                <p
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  {item?.groupConfigName}
                </p>
              </Col>
              {isSelected && <Tick size={15} />}
            </Row>
          </ConfigItem>
        </GroupConfigItemInner>
        <div
          style={{
            display: "flex",
            gap: "6px",
          }}
        >
          <EditIcon
            withShadow={false}
            accentColor="var(--danger)"
            Icon={Pencil}
            onClick={onClick}
            title={"Remove activity"}
            style={{ width: "37px", marginTop: "0" }}
          />
          {onDelete && (
            <DeleteButton
              withShadow={false}
              accentColor="var(--danger)"
              Icon={Delete}
              onClick={onDelete}
              title={"Remove activity"}
              style={{ width: "37px" }}
            />
          )}
        </div>
      </GroupConfigItem>
    </div>
  );
};

export const GroupConfigItem = styled(Row)`
  width: 100%;
  gap: 5px;
  align-items: stretch;
`;

export const DeleteButton = styled(IconButtonInverted)`
  padding: 4px 6px; // Slightly smaller padding
  min-width: 20px; // Reduced width
  height: 100%;

  svg {
    max-width: 14px; // Reduced icon size
    path {
      fill: black;
    }
  }
`;

export const EditIcon = styled(IconButtonInverted)`
  padding: 4px 6px; // Slightly smaller padding
  min-width: 20px; // Reduced width
  height: 100%;
  margin-top: 6px; // Adds space between the Delete and Edit icons

  svg {
    max-width: 14px; // Reduced icon size
    path {
      fill: black;
    }
  }
`;

export const ConfigItem = styled(Button)<{ color: string }>`
  width: 100%;
  background-color: ${(props) => props.color};
  border-radius: 8px;
  padding: 10px;
  box-shadow: none;
  min-width: 0;
  color: white;

  ${Row} {
    height: 100%;
    width: 100%;
    justify-content: space-between;
    margin-right: 15px;

    ${Col} {
      min-width: 0;
      flex: 0.7;
      line-height: 1.3em;
      width: 100%;
      overflow: hidden;
      word-break: break-word;
      text-align: left;
    }
  }
`;

export const GroupConfigItemInner = styled(Row)`
  flex-grow: 1;
`;
